<script setup lang="ts">
const { client } = usePrismic();
const { locale, localeProperties } = useI18n();
const { alternateLanguages } = storeToRefs(usePageStore());

const { data: document, error } = await useAsyncData(
  `bim_hub-${locale.value}`,
  async () => {
    const document = await client.getSingle("bim_hub", {
      lang: localeProperties.value.language,
    });
    return document;
  },
);

if (error.value) {
  console.log("HERE", error.value);
  throw createError({ statusCode: 404, message: "Page not found" });
}

definePageMeta({
  layout: "bim",
});

onNuxtReady(() => {
  alternateLanguages.value = document.value?.alternate_languages || [];
});
</script>

<template>
  <PageBimHub v-if="document" :document="document" />
</template>
